export default {
  path: 'workflow',
  name: 'subscription',
  props: true,
  meta: { requiresAuth: true },
  component: () => import(/* webpackChunkName: "subscription-show-workflow" */ './Workflow')
}
